import api from './api';

const authService = {
    login: async (email, password) => {
        const loginObject = {
            "eposta": email,
            "sifre": password,
            "rol": "2"
        };
        const response = await api.post('/login', loginObject);
        return response.data;
    },

    refreshToken: async (token) => {
        // Döngüsel bağımlılığı önlemek için bu metod doğrudan api.js interceptor'ında
        // değil, gerekirse bileşenlerden çağrılmak üzere tutulmaktadır.
        const response = await api.post('/login/refreshtoken', JSON.stringify(token), {
            headers: { 'Content-Type': 'application/json' },
        });
        return response.data;
    },

    resendActivation: async (email) => {
        const response = await api.post('/login/resendactivation', {
            eposta: email,
            rol: "2"
        });
        return response.data;
    },
};

export default authService;
